import React from "react";
import { Card } from "../../../../shared/Card/Card";
import { getOverallScore, getScoreColor } from "./utils/rubricUtils";
import "./tabs.scss";

interface InterviewRubricStatsProps {
  feedback: any;
  evaluations: any[];
  interview: any;
}

const InterviewRubricStats: React.FC<InterviewRubricStatsProps> = ({
  feedback,
  evaluations,
  interview,
}) => {
  const overallScore = getOverallScore(feedback);

  return (
    <div className="stats-grid">
      <Card>
        <div className="stat-card">
          <h3 className="stat-label">Overall Score</h3>
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{
                width: `${overallScore}%`,
                backgroundColor: getScoreColor(overallScore),
              }}
            />
          </div>
          <p
            className="stat-value"
            style={{ color: getScoreColor(overallScore) }}
          >
            {overallScore}%
          </p>
        </div>
      </Card>

      <Card>
        <div className="stat-card">
          <h3 className="stat-label">Questions Answered</h3>
          <p className="stat-value primary">
            {evaluations.length}/{feedback.totalQuestions || evaluations.length}
          </p>
          <p className="stat-subtext">
            {Math.round(
              (evaluations.length /
                (feedback.totalQuestions || evaluations.length)) *
                100
            )}
            % completion rate
          </p>
        </div>
      </Card>

      <Card>
        <div className="stat-card">
          <h3 className="stat-label">Interview Duration</h3>
          <p className="stat-value primary">
            {feedback.interviewDuration || interview.duration || "N/A"}
          </p>
          <p className="stat-subtext">Minutes</p>
        </div>
      </Card>
    </div>
  );
};

export default InterviewRubricStats;

